import React, { Component } from "react";

import Headbody from "../../components/head-body";
import Menu from "../../components/menu";
import Devsolucoes from "../../components/dev-solucoes";
import Footer from "../../components/footer";
import Endbody from "../../components/end-body";


class Grato extends Component {
  
    render() {
      return (
          <React.Fragment>
                <Headbody></Headbody>
                <Menu></Menu>
                <section class="header-interno padrao">
                  <div class="container">
                    <h1>Grato!</h1>
                  </div>
                </section>

                <section class="conteudo-interno">
                  <div class="container">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <div class="titulo-int">
                        <h2>Mensagem enviada com sucesso!</h2>
                      </div>
                    </div>
                  </div>

                </section>

                <Footer></Footer>
                <Endbody></Endbody>
          </React.Fragment>
        
      );
    }
  }

export default Grato;